<template>
  <div>
    <vxe-grid
      border
      round
      resizable
      class="mt-2"
      ref="xTable1"
      height="500"
      :data="tableData"
      :loading="loading"
      :columns="tableColumn"
      :tree-config="treeConfig"
      :checkbox-config="{checkMethod: checkboxAvailable}"
    ></vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      // 选中的数据
      multipleSelection: [],
      treeConfig: {
        children: "itemList",
        expandAll: false
      },
      tableColumn: [
        { type: "checkbox", width: 50 },
        { type: "seq", width: 50 },
        {
          field: "appraisalGroupName",
          title: this.$l("label_nameOfScoringGroup") || "评分组名称",
          width: 260,
          treeNode: true
        },
        {
          field: "appraisalGroupNameEn",
          title: this.$l("label_nameOfScoringGroupEn") || "评分组名称英文",
          minWidth: 260
        },
        {
          field: "appraisalGroupTopScore",
          title: this.$l("label_totalScore") || "总分",
          width: 80,
          align: "center"
        }
      ]
    };
  },
  methods: {
    selectionChange() {
      return this.$refs.xTable1.getCheckboxRecords();
    },
    // 复选框是否可用
    checkboxAvailable({ row }) {
      return row.level === "1";
    }
  }
};
</script>
